import { EntityMultiValuedListMoreItem } from '../../Entity'

import FlatIcon from '../../../icons/flat.svg'

function FlatMultiValuedListMoreItem({ ref, ...props }) {
  return <EntityMultiValuedListMoreItem {...props} Icon={FlatIcon} ref={ref} />
}

export default FlatMultiValuedListMoreItem
